(function() {
  'use strict';

  // State
  var allGames = [];
  var selectedGames = [];
  var freitextGames = [];
  var uploadedFiles = [];

  // DOM Elements
  var searchInput = document.getElementById('ankauf-search');
  var searchResults = document.getElementById('ankauf-search-results');
  var selectedList = document.getElementById('ankauf-selected-list');
  var selectedSection = document.getElementById('ankauf-selected-section');
  var totalPrice = document.getElementById('ankauf-total-price');
  var dropzone = document.getElementById('ankauf-dropzone');
  var fileInput = document.getElementById('ankauf-file-input');
  var previews = document.getElementById('ankauf-previews');
  var form = document.getElementById('ankauf-form');
  var statusEl = document.getElementById('ankauf-status');
  var submitBtn = document.getElementById('ankauf-submit-btn');
  var freitextEntries = document.getElementById('ankauf-freitext-entries');
  var freitextInput = document.getElementById('ankauf-freitext-input');
  var freitextDetails = document.getElementById('ankauf-freitext-details');
  var freitextEan = document.getElementById('ankauf-freitext-ean');
  var freitextZustand = document.getElementById('ankauf-freitext-zustand');
  var freitextAddBtn = document.getElementById('ankauf-freitext-add');
  var freitextHidden = document.getElementById('ankauf-freitext');

  var ZUSTAND_OPTIONS = [
    { value: 'Gebraucht / Vollständig', label: 'Gebraucht / Vollständig' },
    { value: 'Gebraucht / Unbespielt', label: 'Gebraucht / Unbespielt' },
    { value: 'Neu / OVP', label: 'Neu / OVP' }
  ];

  var WEBHOOK_URL = form ? form.dataset.webhookUrl : '';

  // Spiele-Daten laden (nur gebrauchte / Grundpreise)
  async function loadGames() {
    try {
      var url = document.getElementById('ankauf-data-url')?.value;
      if (!url) return;
      var response = await fetch(url);
      var data = await response.json();
      // Einträge ohne Bild-URL entfernen, damit die Auswahlliste keine leeren Bildplätze zeigt
      data = data.filter(function(g) {
        return g && g.image && String(g.image).trim().length > 0;
      });

      // Duplikate nach title entfernen, nur den ersten behalten
      var seen = {};
      allGames = [];
      for (var i = 0; i < data.length; i++) {
        var key = data[i].title.toLowerCase().replace(/\s*\(.*?\)\s*$/, '').trim();
        if (!seen[key]) {
          seen[key] = true;
          allGames.push(data[i]);
        }
      }
    } catch (e) {
      console.error('Ankaufspreise konnten nicht geladen werden:', e);
    }
  }

  // Zustand-Dropdown HTML
  function zustandSelectHtml(selectedValue, index, prefix) {
    var html = '<select class="ankauf-zustand-select" data-prefix="' + prefix + '" data-index="' + index + '">';
    for (var i = 0; i < ZUSTAND_OPTIONS.length; i++) {
      var opt = ZUSTAND_OPTIONS[i];
      html += '<option value="' + opt.value + '"' + (opt.value === selectedValue ? ' selected' : '') + '>' + opt.label + '</option>';
    }
    html += '</select>';
    return html;
  }

  // EAN-Suche: Spiel per EAN/Barcode finden
  function findGameByEan(ean) {
    var cleaned = ean.replace(/\s+/g, '').trim();
    return allGames.find(function(g) {
      return g.ean && g.ean.replace(/\s+/g, '').trim() === cleaned;
    });
  }

  // Suche (Name oder EAN)
  function handleSearch() {
    var query = searchInput.value.trim().toLowerCase();
    if (query.length < 2) {
      searchResults.classList.remove('active');
      return;
    }

    // Prüfe ob Eingabe eine EAN ist (nur Ziffern, 8-13 Zeichen)
    var isEan = /^\d{8,13}$/.test(query.trim());
    if (isEan) {
      var eanMatch = findGameByEan(query.trim());
      if (eanMatch && !selectedGames.find(function(s) { return s.title.toLowerCase() === eanMatch.title.toLowerCase(); })) {
        searchResults.innerHTML = '<div class="ankauf-search-item" data-title="' + escapeHtml(eanMatch.title) + '" data-price="' + eanMatch.price + '" data-image="' + escapeHtml(eanMatch.image || '') + '">' +
          (eanMatch.image ? '<img src="' + escapeHtml(eanMatch.image) + '" alt="' + escapeHtml(eanMatch.title) + '" loading="lazy">' : '') +
          '<div class="ankauf-search-item-info">' +
          '<div class="ankauf-search-item-title">' + escapeHtml(eanMatch.title) + '</div>' +
          '<div class="ankauf-search-item-price">ca. ' + formatPrice(eanMatch.price) + '</div>' +
          '<div class="ankauf-search-item-ean">EAN: ' + escapeHtml(eanMatch.ean) + '</div>' +
          '</div></div>';
        searchResults.classList.add('active');
        return;
      }
      searchResults.innerHTML = '<div class="ankauf-no-results">Kein Spiel mit EAN ' + escapeHtml(query) + ' gefunden. Du kannst es unten manuell hinzufügen.</div>';
      searchResults.classList.add('active');
      return;
    }

    var words = query.split(/\s+/).filter(function(w) { return w.length > 0; });
    var results = allGames
      .filter(function(g) {
        var title = g.title.toLowerCase();
        return words.every(function(w) { return title.includes(w); });
      })
      .filter(function(g) {
        return !selectedGames.find(function(s) { return s.title.toLowerCase() === g.title.toLowerCase(); });
      });

    if (results.length === 0) {
      searchResults.innerHTML = '<div class="ankauf-no-results">Kein Spiel gefunden. Du kannst es unten manuell hinzufügen.</div>';
    } else {
      searchResults.innerHTML = results.map(function(g) {
        return '<div class="ankauf-search-item" data-title="' + escapeHtml(g.title) + '" data-price="' + g.price + '" data-image="' + escapeHtml(g.image || '') + '">' +
          (g.image ? '<img src="' + escapeHtml(g.image) + '" alt="' + escapeHtml(g.title) + '" loading="lazy">' : '') +
          '<div class="ankauf-search-item-info">' +
          '<div class="ankauf-search-item-title">' + escapeHtml(g.title) + '</div>' +
          '<div class="ankauf-search-item-price">ca. ' + formatPrice(g.price) + '</div>' +
          '</div></div>';
      }).join('');
    }
    searchResults.classList.add('active');
  }

  // Alle Spiele alphabetisch anzeigen
  function showAllGames() {
    var sorted = allGames
      .filter(function(g) {
        return !selectedGames.find(function(s) { return s.title.toLowerCase() === g.title.toLowerCase(); });
      })
      .sort(function(a, b) { return a.title.localeCompare(b.title, 'de'); });

    if (sorted.length === 0) return;

    searchResults.innerHTML = sorted.map(function(g) {
      return '<div class="ankauf-search-item" data-title="' + escapeHtml(g.title) + '" data-price="' + g.price + '" data-image="' + escapeHtml(g.image || '') + '">' +
        (g.image ? '<img src="' + escapeHtml(g.image) + '" alt="' + escapeHtml(g.title) + '" loading="lazy">' : '') +
        '<div class="ankauf-search-item-info">' +
        '<div class="ankauf-search-item-title">' + escapeHtml(g.title) + '</div>' +
        '<div class="ankauf-search-item-price">ca. ' + formatPrice(g.price) + '</div>' +
        '</div></div>';
    }).join('');
    searchResults.classList.add('active');
  }

  // Spiel auswählen
  function selectGame(title, price, image) {
    if (selectedGames.find(function(g) { return g.title.toLowerCase() === title.toLowerCase(); })) return;
    selectedGames.push({ title: title, price: parseFloat(price), image: image, zustand: 'Gebraucht / Vollständig' });
    searchInput.value = '';
    searchResults.classList.remove('active');
    renderSelected();
  }

  // Spiel entfernen
  function removeGame(index) {
    selectedGames.splice(index, 1);
    renderSelected();
  }

  // Zustand ändern
  function changeZustand(prefix, index, value) {
    if (prefix === 'sel') {
      selectedGames[index].zustand = value;
    } else if (prefix === 'ft') {
      freitextGames[index].zustand = value;
      updateFreitextHidden();
    }
  }

  // Ausgewählte Spiele rendern
  function renderSelected() {
    if (!selectedSection || !selectedList || !totalPrice) return;
    if (selectedGames.length === 0) {
      selectedSection.style.display = 'none';
      return;
    }
    selectedSection.style.display = 'block';

    selectedList.innerHTML = selectedGames.map(function(g, i) {
      return '<li class="ankauf-selected-item">' +
        (g.image ? '<img src="' + escapeHtml(g.image) + '" alt="' + escapeHtml(g.title) + '" loading="lazy">' : '') +
        '<div class="ankauf-selected-item-info">' +
        '<div class="ankauf-selected-item-title">' + escapeHtml(g.title) + '</div>' +
        '<div class="ankauf-selected-item-price">ca. ' + formatPrice(g.price) + '</div>' +
        '<div class="ankauf-selected-item-zustand">' + zustandSelectHtml(g.zustand, i, 'sel') + '</div>' +
        '</div>' +
        '<button type="button" class="ankauf-selected-item-remove" data-index="' + i + '" aria-label="Entfernen">&times;</button>' +
        '</li>';
    }).join('');

    var total = selectedGames.reduce(function(sum, g) { return sum + g.price; }, 0);
    totalPrice.textContent = formatPrice(total);
  }

  // === Freitext Spiele ===
  function addFreitextGame() {
    var title = freitextInput.value.trim();
    if (!title) return;
    var details = freitextDetails ? freitextDetails.value.trim() : '';
    var ean = freitextEan ? freitextEan.value.replace(/\s+/g, '').trim() : '';
    var zustand = freitextZustand.value;
    freitextGames.push({ title: title, details: details, ean: ean, zustand: zustand });
    freitextInput.value = '';
    if (freitextDetails) freitextDetails.value = '';
    if (freitextEan) freitextEan.value = '';
    renderFreitextGames();
    updateFreitextHidden();
  }

  function removeFreitextGame(index) {
    freitextGames.splice(index, 1);
    renderFreitextGames();
    updateFreitextHidden();
  }

  function renderFreitextGames() {
    if (!freitextEntries) return;
    if (freitextGames.length === 0) {
      freitextEntries.innerHTML = '';
      return;
    }
    freitextEntries.innerHTML = freitextGames.map(function(g, i) {
      var meta = [];
      if (g.details) meta.push('Details: ' + escapeHtml(g.details));
      if (g.ean) meta.push('EAN: ' + escapeHtml(g.ean));
      return '<div class="ankauf-freitext-entry">' +
        '<div class="ankauf-freitext-entry-info">' +
          '<span class="ankauf-freitext-entry-title">' + escapeHtml(g.title) + '</span>' +
          (meta.length ? '<span class="ankauf-freitext-entry-meta">' + meta.join(' · ') + '</span>' : '') +
        '</div>' +
        zustandSelectHtml(g.zustand, i, 'ft') +
        '<button type="button" class="ankauf-freitext-entry-remove" data-ft-index="' + i + '" aria-label="Entfernen">&times;</button>' +
        '</div>';
    }).join('');
  }

  function updateFreitextHidden() {
    if (!freitextHidden) return;
    freitextHidden.value = freitextGames.map(function(g) {
      var parts = [g.title];
      if (g.details) parts.push('Details: ' + g.details);
      if (g.ean) parts.push('EAN: ' + g.ean);
      parts.push('Zustand: ' + g.zustand);
      return parts.join(' | ');
    }).join('\n');
  }

  // Bild-Upload
  function setupDropzone() {
    if (!dropzone) return;
    dropzone.addEventListener('click', function() { fileInput.click(); });
    dropzone.addEventListener('dragover', function(e) { e.preventDefault(); dropzone.classList.add('dragover'); });
    dropzone.addEventListener('dragleave', function() { dropzone.classList.remove('dragover'); });
    dropzone.addEventListener('drop', function(e) { e.preventDefault(); dropzone.classList.remove('dragover'); handleFiles(e.dataTransfer.files); });
    fileInput.addEventListener('change', function() { handleFiles(fileInput.files); fileInput.value = ''; });
  }

  function handleFiles(files) {
    for (var i = 0; i < files.length; i++) {
      if (!files[i].type.startsWith('image/')) continue;
      if (uploadedFiles.length >= 10) break;
      uploadedFiles.push(files[i]);
    }
    renderPreviews();
  }

  function removeFile(index) {
    uploadedFiles.splice(index, 1);
    renderPreviews();
  }

  function renderPreviews() {
    previews.innerHTML = uploadedFiles.map(function(file, i) {
      var url = URL.createObjectURL(file);
      return '<div class="ankauf-preview">' +
        '<img src="' + url + '" alt="' + escapeHtml(file.name) + '">' +
        '<button type="button" class="ankauf-preview-remove" data-file-index="' + i + '" aria-label="Bild entfernen">&times;</button>' +
        '</div>';
    }).join('');
  }

  // Formular absenden
  async function handleSubmit(e) {
    e.preventDefault();

    // Falls der Kunde einen Spieltitel eingetragen, aber nicht auf "Hinzufügen" geklickt hat,
    // übernehmen wir die Eingabe beim Absenden automatisch. Sonst entsteht eine Anfrage nur mit Kontaktdaten.
    if (freitextInput && freitextInput.value.trim()) {
      addFreitextGame();
    }

    var name = document.getElementById('ankauf-name').value.trim();
    var email = document.getElementById('ankauf-email').value.trim();
    var plz = document.getElementById('ankauf-plz').value.trim();
    var message = document.getElementById('ankauf-message').value.trim();
    var freitext = freitextHidden ? freitextHidden.value : '';

    if (!name || !email || !plz) {
      showStatus('Bitte Name, E-Mail und PLZ ausfüllen.', 'error');
      return;
    }

    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
      showStatus('Bitte gib eine gültige E-Mail-Adresse ein.', 'error');
      return;
    }

    if (!freitext && selectedGames.length === 0 && uploadedFiles.length === 0 && !message) {
      showStatus('Bitte trage mindestens ein Spiel ein oder lade ein Foto hoch.', 'error');
      return;
    }

    var agbChecked = document.getElementById('ankauf-agb').checked;
    var dsChecked = document.getElementById('ankauf-datenschutz').checked;
    if (!agbChecked || !dsChecked) {
      showStatus('Bitte stimme den AGB und der Datenschutzerklärung zu.', 'error');
      return;
    }

    showStatus('Anfrage wird gesendet...', 'loading');
    submitBtn.disabled = true;

    try {
      var formData = new FormData();
      formData.append('name', name);
      formData.append('email', email);
      formData.append('plz', plz);
      formData.append('message', message);
      formData.append('freitext_spiele', freitext);
      formData.append('ausgewaehlte_spiele', JSON.stringify(selectedGames.map(function(g) {
        return { title: g.title, price: g.price, image: g.image, zustand: g.zustand };
      })));
      formData.append('gesamtpreis', selectedGames.reduce(function(sum, g) { return sum + g.price; }, 0).toFixed(2));

      for (var i = 0; i < uploadedFiles.length; i++) {
        formData.append('bilder', uploadedFiles[i]);
      }

      var response = await fetch(WEBHOOK_URL, { method: 'POST', body: formData });

      var responseText = '';
      var result = null;
      try { responseText = await response.text(); } catch(e2) {}
      if (responseText) {
        try { result = JSON.parse(responseText); } catch(e3) {}
      }

      if (result && result.success === false) {
        showStatus('Deine Anfrage konnte nicht gesendet werden: ' + (result.error || 'Bitte versuche es erneut.'), 'error');
      } else if (response.ok && result && result.success === true) {
        showStatus('Vielen Dank! Deine Ankauf-Anfrage wurde erfolgreich gesendet. Wir melden uns in Kürze bei dir.', 'success');
        selectedGames = [];
        freitextGames = [];
        uploadedFiles = [];
        renderSelected();
        renderFreitextGames();
        updateFreitextHidden();
        renderPreviews();
        form.reset();
      } else {
        throw new Error('Server error');
      }
    } catch (err) {
      showStatus('Es ist ein Fehler aufgetreten. Bitte versuche es erneut oder kontaktiere uns direkt.', 'error');
      console.error('Ankauf submit error:', err);
    } finally {
      submitBtn.disabled = false;
    }
  }

  // Hilfsfunktionen
  function formatPrice(price) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(price);
  }

  function escapeHtml(str) {
    if (!str) return '';
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  function showStatus(msg, type) {
    statusEl.textContent = msg;
    statusEl.className = 'ankauf-status ' + type;
  }

  // Spiele mit nicht ladbarem Bild aus der Auswahlliste entfernen.
  // Das betrifft nur die Such-/Auswahlliste; manuelle Eingaben bleiben unverändert möglich.
  function setupBrokenImageFilter() {
    document.addEventListener('error', function(e) {
      var img = e.target;
      if (!img || img.tagName !== 'IMG') return;

      var searchItem = img.closest ? img.closest('.ankauf-search-item') : null;
      if (searchItem && searchResults && searchResults.contains(searchItem)) {
        searchItem.remove();
        if (searchResults.classList.contains('active') && !searchResults.querySelector('.ankauf-search-item')) {
          searchResults.innerHTML = '<div class="ankauf-no-results">Kein Spiel mit Bild gefunden. Du kannst es unten manuell hinzufügen.</div>';
        }
        return;
      }

      var selectedItem = img.closest ? img.closest('.ankauf-selected-item') : null;
      if (selectedItem) {
        img.remove();
      }
    }, true);
  }

  // Event Delegation
  document.addEventListener('click', function(e) {
    var searchItem = e.target.closest('.ankauf-search-item');
    if (searchItem) {
      selectGame(searchItem.dataset.title, searchItem.dataset.price, searchItem.dataset.image);
      return;
    }

    var removeBtn = e.target.closest('.ankauf-selected-item-remove');
    if (removeBtn) {
      removeGame(parseInt(removeBtn.dataset.index));
      return;
    }

    var ftRemoveBtn = e.target.closest('.ankauf-freitext-entry-remove');
    if (ftRemoveBtn) {
      removeFreitextGame(parseInt(ftRemoveBtn.dataset.ftIndex));
      return;
    }

    var fileRemoveBtn = e.target.closest('.ankauf-preview-remove');
    if (fileRemoveBtn) {
      removeFile(parseInt(fileRemoveBtn.dataset.fileIndex));
      return;
    }

    if (searchResults && !e.target.closest('.ankauf-search-wrapper')) {
      searchResults.classList.remove('active');
    }
  });

  // Zustand-Dropdown change
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('ankauf-zustand-select') && e.target.dataset.prefix) {
      changeZustand(e.target.dataset.prefix, parseInt(e.target.dataset.index), e.target.value);
    }
  });

  // Freitext hinzufügen
  if (freitextAddBtn) {
    freitextAddBtn.addEventListener('click', addFreitextGame);
  }
  if (freitextInput) {
    freitextInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        if (freitextDetails) {
          freitextDetails.focus();
        } else {
          addFreitextGame();
        }
      }
    });
  }
  [freitextDetails, freitextEan].forEach(function(input) {
    if (!input) return;
    input.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        addFreitextGame();
      }
    });
  });

  // Debounced Search
  var searchTimeout;
  if (searchInput) {
    searchInput.addEventListener('input', function() {
      clearTimeout(searchTimeout);
      searchTimeout = setTimeout(handleSearch, 200);
    });

    searchInput.addEventListener('focus', function() {
      if (searchInput.value.trim().length >= 2) {
        handleSearch();
      } else {
        showAllGames();
      }
    });

    searchInput.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        var items = searchResults.querySelectorAll('.ankauf-search-item');
        if (items.length === 1) {
          selectGame(items[0].dataset.title, items[0].dataset.price, items[0].dataset.image);
        }
      }
    });
  }

  if (form) {
    form.addEventListener('submit', handleSubmit);
  }

  // Ankaufsbedingungen Modal
  var bedModal = document.getElementById('ankauf-bedingungen-modal');
  var bedLink = document.getElementById('ankauf-bedingungen-link');
  var bedClose = document.getElementById('ankauf-bedingungen-close');

  if (bedLink && bedModal) {
    bedLink.addEventListener('click', function(e) {
      e.preventDefault();
      bedModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
    });
  }
  if (bedClose && bedModal) {
    bedClose.addEventListener('click', function() {
      bedModal.style.display = 'none';
      document.body.style.overflow = '';
    });
  }
  if (bedModal) {
    bedModal.addEventListener('click', function(e) {
      if (e.target === bedModal) {
        bedModal.style.display = 'none';
        document.body.style.overflow = '';
      }
    });
  }

  // EAN Barcode Scanner
  var scanBtn = document.getElementById('ankauf-scan-btn');
  var eanScanBtn = document.getElementById('ankauf-ean-scan-btn');
  var scannerContainer = document.getElementById('ankauf-scanner-container');
  var scannerClose = document.getElementById('ankauf-scanner-close');
  var scannerStatus = document.getElementById('ankauf-scanner-status');
  var html5QrcodeScanner = null;
  var scannerMode = 'search';

  function startScanner() {
    if (!scannerContainer || !scannerStatus) return;
    if (typeof Html5Qrcode === 'undefined') {
      scannerStatus.textContent = 'Scanner-Bibliothek konnte nicht geladen werden.';
      scannerStatus.style.color = '#c00';
      return;
    }

    // Container erst sichtbar machen, dann kurz warten damit das DOM rendern kann
    scannerContainer.style.display = 'block';
    scannerStatus.textContent = 'Kamera wird gestartet...';
    scannerStatus.style.color = '';

    // Alten Scanner-Inhalt aufräumen
    var readerEl = document.getElementById('ankauf-scanner-reader');
    readerEl.innerHTML = '';

    setTimeout(function() {
      // Barcode-Formate explizit aktivieren (EAN, UPC)
      var formatsToSupport = [
        Html5QrcodeSupportedFormats.EAN_13,
        Html5QrcodeSupportedFormats.EAN_8,
        Html5QrcodeSupportedFormats.UPC_A,
        Html5QrcodeSupportedFormats.UPC_E,
        Html5QrcodeSupportedFormats.CODE_128,
        Html5QrcodeSupportedFormats.CODE_39
      ];
      html5QrcodeScanner = new Html5Qrcode('ankauf-scanner-reader', {
        formatsToSupport: formatsToSupport,
        experimentalFeatures: { useBarCodeDetectorIfSupported: true },
        verbose: false
      });

      // qrbox als Funktion: wird bei jedem Frame mit der tatsächlichen
      // Video-Größe aufgerufen → passt sich immer korrekt an
      function qrboxFunction(viewfinderWidth, viewfinderHeight) {
        var w = Math.floor(viewfinderWidth * 0.7);
        var h = Math.floor(viewfinderHeight * 0.35);
        if (w < 150) w = 150;
        if (h < 60) h = 60;
        if (w > viewfinderWidth - 20) w = viewfinderWidth - 20;
        if (h > viewfinderHeight - 20) h = viewfinderHeight - 20;
        return { width: w, height: h };
      }

      html5QrcodeScanner.start(
        { facingMode: 'environment' },
        {
          fps: 15,
          qrbox: qrboxFunction,
          disableFlip: false
        },
        function onScanSuccess(decodedText) {
          var cleaned = decodedText.replace(/\s+/g, '').trim();
          stopScanner();

          if (scannerMode === 'manual') {
            if (freitextEan) {
              freitextEan.value = cleaned;
              freitextEan.focus();
            }
            showScannerResult('EAN übernommen: ' + cleaned, '#090');
            return;
          }

          var game = findGameByEan(cleaned);
          if (game) {
            if (!selectedGames.find(function(s) { return s.title.toLowerCase() === game.title.toLowerCase(); })) {
              selectGame(game.title, game.price, game.image);
              showScannerResult('Gefunden: ' + game.title, '#090');
            } else {
              showScannerResult(game.title + ' ist bereits in deiner Liste.', '#c60');
            }
          } else if (searchInput) {
            searchInput.value = cleaned;
            handleSearch();
            showScannerResult('EAN ' + cleaned + ' nicht gefunden. Du kannst das Spiel unten manuell hinzufügen.', '#c00');
          } else {
            showScannerResult('EAN erkannt: ' + cleaned, '#090');
          }
        },
        function onScanFailure() {}
      ).then(function() {
        scannerStatus.textContent = 'Kamera aktiv — halte den Barcode vor die Kamera. Das Kamerabild dient ausschließlich zur Erkennung des Barcodes und wird nicht gespeichert.';
        // Zoom + Autofokus über Video-Track aktivieren (Fallback)
        try {
          var videoEl = readerEl.querySelector('video');
          if (videoEl && videoEl.srcObject) {
            var track = videoEl.srcObject.getVideoTracks()[0];
            if (track) {
              var caps = track.getCapabilities ? track.getCapabilities() : {};
              var constraints = {};
              if (caps.zoom) {
                constraints.zoom = Math.min(2.0, caps.zoom.max || 2.0);
              }
              if (caps.focusMode && caps.focusMode.indexOf('continuous') !== -1) {
                constraints.focusMode = 'continuous';
              }
              if (Object.keys(constraints).length > 0) {
                track.applyConstraints({ advanced: [constraints] });
              }
            }
          }
        } catch(e) {}
        // Shaded Region (dunkles Overlay um Scan-Box) aufhellen
        var shadedRegions = readerEl.querySelectorAll('[style*="border-width"]');
        shadedRegions.forEach(function(el) {
          el.style.background = 'rgba(0, 0, 0, 0.15)';
        });
        // Fallback: alle Elemente mit schwarzem rgba-Hintergrund aufhellen
        if (shadedRegions.length === 0) {
          var allDivs = readerEl.querySelectorAll('div');
          allDivs.forEach(function(el) {
            var bg = el.style.background || el.style.backgroundColor || '';
            if (bg.indexOf('rgba(0, 0, 0') !== -1 && bg.indexOf('0.') !== -1) {
              el.style.background = 'rgba(0, 0, 0, 0.15)';
            }
          });
        }
      }).catch(function(err) {
        scannerStatus.textContent = 'Kamera konnte nicht gestartet werden. Bitte erlaube den Kamera-Zugriff in deinen Browser-Einstellungen.';
        scannerStatus.style.color = '#c00';
        console.error('Scanner error:', err);
      });
    }, 500);
  }

  function showScannerResult(msg, color) {
    if (!scannerStatus || !scannerContainer) return;
    scannerStatus.textContent = msg;
    scannerStatus.style.color = color;
    scannerContainer.style.display = 'block';
  }

  function stopScanner() {
    if (html5QrcodeScanner) {
      try {
        html5QrcodeScanner.stop().then(function() {
          html5QrcodeScanner.clear();
          html5QrcodeScanner = null;
        }).catch(function() {
          try { html5QrcodeScanner.clear(); } catch(e) {}
          html5QrcodeScanner = null;
        });
      } catch(e) {
        html5QrcodeScanner = null;
      }
    }
    if (scannerContainer) scannerContainer.style.display = 'none';
  }

  if (scanBtn) {
    scanBtn.addEventListener('click', function() {
      scannerMode = 'search';
      if (scannerContainer.style.display === 'none' || scannerContainer.style.display === '') {
        startScanner();
      } else {
        stopScanner();
      }
    });
  }

  if (eanScanBtn) {
    eanScanBtn.addEventListener('click', function() {
      scannerMode = 'manual';
      if (scannerContainer.style.display === 'none' || scannerContainer.style.display === '') {
        startScanner();
      } else {
        stopScanner();
      }
    });
  }

  if (scannerClose) {
    scannerClose.addEventListener('click', stopScanner);
  }

  // FAQ Accordion
  var faqQuestions = document.querySelectorAll('.ankauf-faq-question');
  faqQuestions.forEach(function(q) {
    q.addEventListener('click', function() {
      var answer = this.nextElementSibling;
      var isOpen = this.getAttribute('aria-expanded') === 'true';
      // Close all
      faqQuestions.forEach(function(other) {
        other.setAttribute('aria-expanded', 'false');
        other.nextElementSibling.classList.remove('open');
      });
      // Toggle clicked
      if (!isOpen) {
        this.setAttribute('aria-expanded', 'true');
        answer.classList.add('open');
      }
    });
    q.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Init
  setupBrokenImageFilter();
  loadGames();
  setupDropzone();
})();
